import apiClient from "lib/api-client"

export const revertAllactionTypeData = async(actionType) =>{
    try {
        const response = await apiClient.post('/api/v1/sync/revertAllDyanamicSyncData',{
            actionType
        });
        return {
            message: response?.data?.message,
            // actions: response?.data?.actions,
            // updatedSyncIds: response?.data?.updatedSyncIds
        };
    } catch (error) {
        console.log("error APi",error)
    }
}